module.exports = __webpack_public_path__ + "static/media/pexels-pavel-danilyuk-6461237.9dcecfab.jpg";